import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';

import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Fade from '@mui/material/Fade';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import {alpha} from "@mui/material";
import { v4 as uuidv4 } from 'uuid';

import {
  TransformWrapper,
  TransformComponent,
  useTransformEffect,
} from "react-zoom-pan-pinch";

import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Bs4I18N from '../Bs4I18N';

import Bs4MainDispatch from '../Bs4MainDispatch';
import Bs4MainWindow from '../Bs4MainWindow';

const mobileBs4GetBase64FromBlobData = (blobUrl, filename, type) => {          
  const xhr = new XMLHttpRequest();  
  xhr.open('GET', blobUrl, true);
  xhr.setRequestHeader('Content-type', type);
  xhr.responseType = 'blob';
  xhr.onload = function(e) {
    if (this.status == 200) {
      const blobData = this.response;
      const reader = new FileReader();
      reader.readAsDataURL(blobData);
      reader.onloadend = function() {
        const base64data = reader.result.split(',', 2)[1];
        URL.revokeObjectURL(blobUrl);
        const androidBs4 = Bs4MainDispatch.getAndroidBs4();          
        if (androidBs4?.viewBase64FileBs4) {
          androidBs4.viewBase64FileBs4(base64data, blobData.type, filename);
        }
        const appleBs4 = Bs4MainDispatch.getAppleBs4();
        if (appleBs4?.viewBase64FileBs4) {
          appleBs4.viewBase64FileBs4.postMessage({
            base64data: base64data,
            type: blobData.type,
            filename: filename,
          });
        }
      }
    }
  };
  xhr.send();
}

const viewPdfOnMobile = (link, fileName) => {    
  fetch(link)
  .then(res => res.blob())
  .then(blob => {
      let objectURL = URL.createObjectURL(blob);
      if (Bs4MainDispatch.getAndroidBs4() || Bs4MainDispatch.getAppleBs4())  {
        mobileBs4GetBase64FromBlobData(objectURL, fileName, blob.type);
      }            
  })
  .catch(error => {
    console.log('...viewPdfOnMobile fetch...', error)  
  }) 
};

const ViewFileTop = (props) => {   
  const colorI = props.file?.iconcolor || "#999999";    
  const colorB = alpha(colorI, 0.2);
  const mainSize = 32;

  const handleClickClose = (event) => {
    props.setFile(null);
  }

  const handleClickDouwnload = (event) => {
    props.onDouwnload();
  }

  const handleClickLeft = (event) => {
    props.onLeft(event);
  }

  const handleClickRight = (event) => {
    props.onRight(event);
  }

  return (
    <Stack 
      direction="row" 
      spacing={2} 
      sx={{
        width: '100%',
        justifyContent: "space-between", 
        alignItems: "center",
        paddingX: 2, 
        paddingY: 0.5, 
        //backgroundColor: '#00000088',
        color: '#ffffff'
      }}
    >
      <IconButton sx={{color: '#ffffff', visibility: props.firstVisibility}} onClick={handleClickLeft}>
        <i className='fa-solid fa-chevron-left'></i>
      </IconButton>           
      <Stack direction="row" spacing={4} sx={{justifyContent: "flex-start", alignItems: "center"}}>   
      <IconButton sx={{color: '#ffffff',}} onClick={handleClickClose}>
          <i className="fa-solid fa-xmark"></i>
        </IconButton>     
      <Stack direction="row" spacing={2} sx={{justifyContent: "flex-start", alignItems: "center"}}>        
        <Avatar sx={{bgcolor: colorB, width: mainSize, height: mainSize, mr: 1, touchAction: 'none'}}>
          <i className={props.file?.icon} style={{color: colorI, fontSize: 18}}/>
        </Avatar>                         
        <Typography sx={{wordBreak: 'break-word'}}>{props.file?.flink}</Typography>
      </Stack>
      <IconButton sx={{color: '#ffffff',}} onClick={handleClickDouwnload}>
        <i className="fa-solid fa-arrow-down-to-bracket"></i>
      </IconButton>
      </Stack>
      <IconButton sx={{color: '#ffffff', visibility: props.lastVisibility}} onClick={handleClickRight}>
        <i className='fa-solid fa-chevron-right'></i>
      </IconButton>      
    </Stack>
  )
};

const ViewImageImg = (props) => {  

  useTransformEffect((args) => {
    props.updateState(args.state);
    return () => {
      // unmount
    };
  });
  
  return (
    <img 
      src={props.src} 
      alt={props.file?.id} 
      onLoad={props.onLoad} 
      // style={{
        // visibility: props.visibility,
        //width: '100%',
        //height: '100%',
        //maxWidth:'100%',
        //loading: 'lazy',
        // objectFit:  'scale-down',
        // imageRendering: 'high-quality',
        // imageRendering: 'crisp-edges',
        // imageRendering: 'smooth',
      // }}
    />
  )
}

export const ViewImage = (props) => {  
  const theme = useTheme();
  const transformComponentRef = React.useRef(null);
  const [fade, setFade] = React.useState(null);
  const [disable, setDisable] = React.useState([false, false, false, false])
  const refBottom = React.useRef(null);
  const [container, setContainer] = React.useState(null);
  const [[containerWidth, containerHeight], setContainerSize] = React.useState([0, 0]);
  const [[imageNaturalWidth, imageNaturalHeight], setImageNaturalSize] = React.useState([0, 0]);  

  const imageScale = React.useMemo(() => {
    if (containerWidth === 0 || containerHeight === 0 || imageNaturalWidth === 0 || imageNaturalHeight === 0) return [1, uuidv4()];    
    const scale = Math.min(containerWidth / imageNaturalWidth, containerHeight / imageNaturalHeight);
    return Math.min(scale, 1);
  }, [containerWidth, containerHeight, imageNaturalWidth, imageNaturalHeight]);

  const height = React.useMemo(() => {
    if (containerWidth === 0 || imageNaturalWidth === 0 || imageNaturalHeight === 0) return 0;
    const height = parseFloat(containerWidth) * parseFloat(imageNaturalHeight) / imageNaturalWidth;
    return Math.min(height, imageNaturalHeight);
  }, [containerWidth, imageNaturalWidth, imageNaturalHeight]);

  React.useEffect(() => {
    const handleResize = (event) => {
      if (container) {
        const rect = container.getBoundingClientRect();
        setContainerSize([rect.width, rect.height]);      
      } else {
        setContainerSize([0, 0]);
      }
    }

    handleResize();
    const resizeObserver = new ResizeObserver(handleResize);
    if (container) resizeObserver.observe(container);
    
    return () => {
      resizeObserver.disconnect();
    }
    
  }, [container, setContainerSize]);

  const handleOnLoad = (event) => {
    setImageNaturalSize([event.target.naturalWidth, event.target.naturalHeight, props.src])
  };

  React.useEffect(() => {
    if (transformComponentRef.current) {
      transformComponentRef.current.centerView(imageScale, 0);
    }
  }, [imageScale, transformComponentRef.current])  

  React.useEffect(() => {
    const handlePointerMove = (event) => {
      if (refBottom?.current) {
        const rect = refBottom.current.getBoundingClientRect();        
        let distanceX = Math.min(Math.abs(rect.left - event.pageX), Math.abs(rect.right - event.pageX));
        if (event.pageX >= rect.left && event.pageX <= rect.right) distanceX = 0;
        
        let distanceY = Math.min(Math.abs(rect.top - event.pageY), Math.abs(rect.bottom - event.pageY));
        if (event.pageY >= rect.top && event.pageY <= rect.bottom) distanceY = 0;
        const distance = Math.max(distanceX, distanceY);
          
        // console.log('...???...pointermove', distance, distanceX, distanceY);
        if (distance < 50) setFade(new Date());
      }         
    }

    window.addEventListener('pointermove', handlePointerMove);

    return () => window.removeEventListener('pointermove', handlePointerMove);
  }, [refBottom?.current, setFade]);  

  const maxScale = 5;

  const updateState = (state) => {
    const scale = state.scale;
    setDisable([scale <= imageScale, scale <= imageScale, scale === 1, scale >= maxScale]);
    // console.log('...???...updateState', state);
    setFade(new Date());
  }

  React.useEffect(() => {
    const pointerMoveTimeout = setTimeout(() => {
      setFade(null);
    }, 500);

    return () => clearTimeout(pointerMoveTimeout);
  }, [fade, setFade]);  

  const handleZoomOut = () => {
    if (transformComponentRef.current) {
      transformComponentRef.current.zoomOut();     
    }
  }

  const handleReset = () => {
    if (transformComponentRef.current) {
      transformComponentRef.current.resetTransform();
    }
  }
  
  const handleZoom1_1 = () => {
    if (transformComponentRef.current) {
      transformComponentRef.current.centerView(1);
    }
  }

  const handleZoomIn = () => {
    if (transformComponentRef.current) {
      transformComponentRef.current.zoomIn();
    }
  }

  return (
    <Box
      ref={setContainer}  
      sx={{
        position: 'relative',
        flex: 1,
        width: props.size?.width ? props.size.width-55 : "100%",
        height: height,
        // backgroundColor: "black",
        ariaHidden: false,
        overflow: 'hidden',
        //border: 'solid #ffff00',
      }}      
    >      
      <TransformWrapper      
        ref={transformComponentRef}  
        initialScale={imageScale}
        minScale={imageScale}
        maxScale={maxScale}
        // wheel={{step: 0.005}}
        // doubleClick={{mode: 'toggle'}}
        // doubleClick={{excluded: ['img']}} ?? nie działa ?????????????
        // centerOnInit // Error ????
        // centerZoomedOut={true}
      >        
        <TransformComponent
          wrapperStyle={{            
            width: "100%",
            height: "100%",
          }}
        >
          <ViewImageImg {...props} onLoad={handleOnLoad} updateState={updateState}/>
        </TransformComponent>
      </TransformWrapper>            
      <Fade in={Boolean(fade)} timeout={1000}>
        <Stack        
          ref={refBottom}
          direction="row"
          spacing={2}
          sx={{
            position: 'absolute',
            left: 'calc(50% - 65px)', 
            bottom: 10,
            justifyContent: "center",
            alignItems: "center",
            padding: 1, 
            color: '#ffffff', 
            backgroundColor: '#000000bb',
            borderRadius: 999,
            boxShadow: theme.shadows[2],
          }}
        >        
          <IconButton disabled={disable[0]} onClick={handleZoomOut} sx={{color: '#ffffff'}}>
            <i className="fa-solid fa-minus"></i>
          </IconButton>
          <IconButton disabled={disable[1]} onClick={handleReset} sx={{color: '#ffffff'}}>
            <i className="fa-solid fa-equals"></i>
          </IconButton>
          <IconButton disabled={disable[2]} onClick={handleZoom1_1} sx={{color: '#ffffff'}}>
            <span>{'1:1'}</span>
          </IconButton>
          <IconButton disabled={disable[3]} onClick={handleZoomIn} sx={{color: '#ffffff'}}>
            <i className="fa-solid fa-plus"></i>
          </IconButton>
        </Stack>
      </Fade>
    </Box>
  );
};

export const ViewPdf = (props) => {  
  
  const handleClick = (event) => {
    viewPdfOnMobile(props.src, props.file?.flink);
  }

  if (Bs4MainDispatch.getAndroidBs4() || Bs4MainDispatch.getAppleBs4()) {
    return (
      <Stack direction="column" spacing={2} sx={{flex: 1, justifyContent: "center", alignItems: "center", color: '#ffffff'}}>      
        <Button onClick={handleClick}>{'Open'}</Button>
      </Stack>
    );
  }

  if (props.formVariant) return <iframe src={props.src} style={{border: 'none', frameBorder:0, width:'100%', aspectRatio: 1}}/>    
  return <iframe src={props.src} style={{border: 'none', frameBorder:0, width: '100%', height:'100%'}}/>;  
};

export const ViewMovie = (props) => {  

  return (
    <iframe src={props.src} 
      style={{
        border: 'none', 
        frameBorder: 0, 
        width: '100%', 
        height: '100%'
      }} 
      // sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
    />
  );
};

export const ViewTextOld = (props) => {  
  const [text, setText] = React.useState('');
  
  React.useEffect(() => {
    fetch(props.src)
    .then( r => r.text() )
    .then( t => {
     setText(t);
    })
    .catch( error => {
      setText(error+'');
    }) 
  }, [props.src, setText]);
  

  return (
    <Box component='span' sx={{color: '#ffffff', overflow: 'auto'}}>
      <pre 
        style={{
          border:'solid #ffff00', 
          // whiteSpace: 'pre-wrap'
        }}
      >
        {text}
      </pre>
      </Box>
  );  
};

export const ViewText = (props) => {  
  const theme = useTheme();
  const WrapLinesTT = Bs4I18N.useTT('Wrap lines', 'Zawijaj wiersze', 'Bs4ViewFiles');  
  const [text, setText] = React.useState('');
  const [toolVisiblity, setToolVisiblity] = React.useState(false);
  const [preWrap, setPreWrap] = React.useState(false);
  const ref = React.useRef(null);
  const [maxHeight, setMaxHeight] = React.useState('100%');
  
  React.useEffect(() => {
    fetch(props.src)
    .then( r => r.text() )
    .then( t => {
     setText(t);
    })
    .catch( error => {
      setText(error+'');
    }) 
  }, [props.src, setText]);


  const handleSelect = (event) => {
    setToolVisiblity(event.type === 'pointerenter');
  }

  const sx = toolVisiblity ? {
    opacity: 1,
    transition: 'opacity 1s',
  } : {
    opacity: 0.1,
    transition: 'opacity 1s',
  };
  
  React.useEffect(() => {
    const handleResize = (event) => {
      if (ref.current && props.formVariant) {
        setMaxHeight((ref.current.offsetWidth * 1.2)+'px');
      }      
    }

    handleResize();
    const resizeObserver = new ResizeObserver(handleResize);
    if (ref.current) resizeObserver.observe(ref.current);
    
    return () => {
      resizeObserver.disconnect();
    }
    
  }, [ref.current, props.formVariant]);

  return (

    <Box       
      sx={{
        position: 'relative',
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.default,
        overflow: 'hidden',    
        width: props.size?.width ? props.size.width-55 : "100%",    
        height: '100%',        
      }}
    >
      <Box 
        ref={ref}
        sx={{
          width: '100%', 
          maxHeight: maxHeight,
          overflow: 'auto',
        }}
      >
        <pre style={preWrap ? {whiteSpace: 'pre-wrap',} : null}>{text}</pre>      
      </Box>
      <Stack        
        direction="row"
        spacing={2}
        sx={{
          ...sx,
          position: 'absolute',
          left: 'calc(50% - 65px)', 
          bottom: 10,
          justifyContent: "center",
          alignItems: "center",
          paddingLeft: 1, 
          paddingRight: 2,
          color: '#ffffff', 
          backgroundColor: '#000000bb',
          // backgroundColor: '#ffffff44',
          borderRadius: 999,
          boxShadow: theme.shadows[2],
          // border: 'solid',
        }}
        onPointerEnter={handleSelect}
        onPointerLeave={handleSelect}
      >        
        <FormControlLabel
          value="bottom"
          control={
            <Checkbox  
              sx={{
                color: '#ffffffcc',
                '&.Mui-checked': {
                  color: '#ffffffff', 
                },
              }}
              checked={preWrap} 
              onChange={event => setPreWrap(event.target.checked)} 
            />
          }
          label={WrapLinesTT}
          // labelPlacement="bottom"
        />        
      </Stack>
    </Box>
  );
};

export const ViewRemote = (props) => {  
  const [src, setSrc] = React.useState(null);

  React.useEffect(() => {
    Bs4MainDispatch.commandParser('bs4FileClick', {targetObject: props.file.id, currFormId: props.currFormId}, props.bs4KartotekaId, (message) => {
      console.log('...???... Files callback', message)    
      setSrc(message._Komunikat.url+'?pid=explorer&efh=false&a=v&chrome=false&embedded=true');
    });
  }, [props.src, setSrc]);

  return (
    <iframe src={src} 
      style={{
        border: 'none', 
        frameBorder: 0, 
        width: '100%', 
        height: '100%'
      }} 
      // sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
    />
  );
};

const ViewUnavailable = (props) => {  
  const theme = useTheme();
  
  const PreviewUnavailableTT = Bs4I18N.useTT('Preview unavailable', 'Podgląd niedostępny', 'Bs4ViewFiles');  

  const handleClickClose = (event) => {
    props.setFile(null);
  }

  const handleClickDouwnload = (event) => {
    props.onDouwnload();
  }

  return (
    <Stack direction="column" spacing={2} sx={{flex: 1, justifyContent: "center", alignItems: "center", color: '#ffffff'}}>
      <Stack 
        direction="column" 
        spacing={2} 
        sx={{
          justifyContent: "center", 
          alignItems: "center", 
          color: '#ffffff',
          padding: 3,
          backgroundColor: '#000000cc',
          borderRadius: 2,
          boxShadow: theme.shadows[5],
        }}
      >
        <Typography variant='h4'>{PreviewUnavailableTT}</Typography>              
        <Stack direction="row" spacing={4} sx={{width: '100%', justifyContent: "space-between", alignItems: "center",}}>   
          <IconButton sx={{color: '#ffffff', fontSize: 34}} onClick={handleClickClose}>
            <i className="fa-solid fa-xmark"></i>
          </IconButton>           
          <IconButton sx={{color: '#ffffff', fontSize: 34}} onClick={handleClickDouwnload}>
            <i className="fa-solid fa-arrow-down-to-bracket"></i>
          </IconButton>
        </Stack>
      </Stack>    
    </Stack>
  );
}

export const Bs4ViewFilesPreview = (props) => {
  if (!props.file) return null;    
  if (!props.open) return null;
  
  const src = Bs4MainDispatch.getUrlPath('showp.php?previewid='+props.file.id); //+'currFormId='+props.currFormId
  const link = Bs4MainDispatch.getUrlPath('showp.php?mid='+props.file.id);

  // if ('pr1' === props.file.preview) return  props.formVariant ? <img src={link} style={{maxWidth:'100%', loading: 'lazy', objectFit: 'scale-down'}}/> : <ViewImage file={props.file} src={src} formVariant={props.formVariant}/>;
  if ('pr1' === props.file.preview) return <ViewImage file={props.file} src={src} formVariant={props.formVariant} size={props.size}/>;
  if ('pr2' === props.file.preview) return <ViewPdf file={props.file} src={src} formVariant={props.formVariant}/>;
  if ('pr3' === props.file.preview) return <ViewMovie file={props.file} src={src} formVariant={props.formVariant}/>;
  if ('pr4' === props.file.preview) return <ViewText file={props.file} src={src} formVariant={props.formVariant} size={props.size}/>;
  // if (parseInt(props.file.remote) === 1) return <ViewRemote {...props}/>;
  if (props.formVariant) return null;
  return <ViewUnavailable setFile={props.setFile} onDouwnload={props.onDouwnload}/>
};

// parms files, file
export const Bs4ViewFiles = (props) => {
  const theme = useTheme();

  const files = React.useMemo(() => {    
    return props.files.filter(file => parseInt(file.remote) !== 1) || []; 
  }, [props.files])

  const [fileIndex, firstFile, lastFile] = React.useMemo(() => {    
    const fileIndex = files?.indexOf(props.file);
    const fileLength = files?.length || null;
    const firstFile = fileIndex === 0;
    const lastFile = fileIndex === (fileLength - 1);
    return [fileIndex, firstFile, lastFile];
  }, [files, props.file]);
  
  const handleClickDouwnload = (event) => {
    if (parseInt(props.file.remote) === 1) {
      // Bs4MainDispatch.commandParser('bs4FileClick', {targetObject: props.file.id, currFormId: props.currFormId}, props.bs4KartotekaId, (message) => {
      //   console.log('...???... Files callback', message)    
      // });
      return;
    }
    Bs4MainDispatch.commandParser('bs4FileClick', {targetObject: props.file.id, currFormId: props.currFormId}, props.bs4KartotekaId);
  }

  const handleClickLeft = (event) => {    
    if (firstFile) return;
    props.setFile(files[fileIndex - 1]);
  }

  const handleClickRight = (event) => {
    if (lastFile) return;
    props.setFile(files[fileIndex + 1]);
  }

  const handleKeyDown = (event) => {
    switch (event.key) {
      case 'Escape':
        props.setFile(null)
        break;

      case 'ArrowRight':
        handleClickRight(event);
        break;

      case 'ArrowLeft':
        handleClickLeft(event);
        break;
    }
  }
  
  const firstVisibility = firstFile ? 'hidden' : 'visible';
  const lastVisibility = lastFile ? 'hidden' : 'visible';

  return (
    <Modal
      open={Boolean(props.file)}
      sx={{
        // ariaHidden: false,
        backgroundColor: '#000000cc',
        // zIndex: (theme) => theme.zIndex.modal * 1,
      }}
    >              
      <Box 
        sx={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden',}}
        onKeyDown={handleKeyDown}
      >
        <ViewFileTop 
          {...props} 
          onDouwnload={handleClickDouwnload} 
          onLeft={handleClickLeft} 
          onRight={handleClickRight} 
          firstVisibility={firstVisibility} 
          lastVisibility={lastVisibility}
        />
        <Bs4ViewFilesPreview {...props} onDouwnload={handleClickDouwnload} open/>
        {/* {view} */}
      </Box>
    </Modal>
  );
}

export default Bs4ViewFiles;